import { PuntoInspeccionViewModel } from 'src/app/components/_mantenimiento/general/puntosinspeccion/puntoinspeccion.types';
import { Tc } from '../../../core/_infrastructure/types/common';
import { TwEnvioTracesViewModel } from '../../../core/_infrastructure/types/web.services';
import { TInspeccionViewModel } from '../inspecciones/inspecciones.types';
import { TPreviaInspectorSolicitudViewModel } from '../previaInspector/previaInspector.types';
import { ConfiguracionImportadorLugarDestinoSolicitudViewModel } from '../importador-lugardestino/importador-lugardestino.types';

export class SolicitudViewModel {
    constructor() {}

    public Id: number;
    public IdPais = 0;
    public IdProvincia = 0;
    public IdPuntoInspeccion = 0;
    public IdTipoSolicitud = 0;
    public IdEstadoChedPp: number | null;
    public IdEstadoChedPpDescripcion: string;
    public IdSubTipoSolicitud: number | null = null;
    public EsExtranjero: boolean | null = false;
    public VieneDePreviaAceptada: boolean | null = false;
    public EsPrevia = false;
    public EsReImportacion = false;
    public IdEstadoSolicitud = 0;
    public IdResultadoEnvioMuestrasLaboratorio: number | null;
    public DescripcionIdResultadoEnvioMuestrasLaboratorio: string;
    public IdTipoAsignacion = 0;
    public FechaDesde: Date;
    public FechaHasta: Date;
    public Codigo: string;
    public FechaEnvio: Date | null;
    public HoraEnvio: string;
    public NombreImportador = '';
    public Nif = '';
    public NRegistro = '';
    public RazonSocial = '';
    public ApellidosInspector = '';
    public NombreInspector = '';
    public RefSolicitante = '';
    public Mrn = '';
    public FechaCreacion: Date;
    public FechaPresentacion: Date | null;
    public IdUsuarioSolicitante: number | null = null;
    public IdInspector: number | null = null;
    //public IdTipoTasa: number | null = null;
    public AplicaTasa: boolean;
    public IdUsuarioSolicitanteAdministrativo: number | null = null;
    //public IdUsuarioGrabador: number | null = null;
    public FechaCartaAutorizacion: Date | null = null;
    public OrganismosCB: boolean | null = null;
    public IdFormatoSolicitud = 0;
    public IsPredua = false;
    public IsCanariasPifCanarias = false;
    public IsPifCanarias = false;
    public Certificado: string;
    public Pin: number;
    public Firmado = false;

    public Enviando = false;

    public DeleteTImportadorYTImportadorLugarDestino = false;

    public TExportador: TExportadorViewModel = new TExportadorViewModel();
    public TImportador: TImportadorViewModel = new TImportadorViewModel();
    public TImportadorLugarDestino: TImportadorLugarDestinoViewModel;
    public TwUsuarioExterno: TUsuarioExternoViewModel = new TUsuarioExternoViewModel();
    public TSolicitanteAdministrativo: TSolicitanteAdministrativoViewModel;
    public TSolicitudAdministrativo: TSolicitudAdministrativoViewModel;
    public TPreviaInspector: TPreviaInspectorSolicitudViewModel;
    public TLugarMercancia: TLugarMercanciaViewModel = new TLugarMercanciaViewModel();
    public TwTraces: TwTracesViewModel = new TwTracesViewModel();
    public TwSolicitudJerarquia: TwSolicitudJerarquiaViewModel;
    public TwEnvioTracesCollection: TwEnvioTracesViewModel[];
    public TwFinalizacionTraslado: TwFinalizacionTrasladoViewModel;
    //public TDocumentoSolicitudCollection: TDocumentoSolicitudViewModel[];

    public TMedioTransporte: TMedioTransporteViewModel = new TMedioTransporteViewModel();
    public TwTraslado: TwTrasladoViewModel;
    public TwTransitoDirecto: TwTransitoDirectoViewModel;
    public TwTransbordo: TwTransbordoViewModel;
    public TcTipoSolicitud: TcTipoSolicitudViewModel = new TcTipoSolicitudViewModel();
    public TcEstadoSolicitud: Tc;
    public TwTcSubTipoSolicitud: TcSubTipoSolicitudViewModel = new TcSubTipoSolicitudViewModel();
    public TwTcEstadoChedPp: Tc;

    public TPuntoInspeccion: PuntoInspeccionViewModel = new PuntoInspeccionViewModel(); //@adua necesario para comprobar si es pif canarias
    public TwInspeccion: TInspeccionViewModel; //necesario para saber que si es un Predua con resultado inspección 'No Procede' entonces no habilitar botón 'Informe CHEDPP'

    //public isCanariasPifCanarias(): boolean {

    //    if (!this.TPuntoInspeccion) {

    //        return false;
    //    }

    //    if (this.IdTipoSolicitud != EnumIdsTcTipoSolicitud.ID_CANARIAS) {

    //        return false;
    //    }

    //    return config
    //        .IdProvinciaCanariasList
    //        .some(s => parseInt(s) == this.TPuntoInspeccion.IdProvincia);

    //    return true;

    //}
}

export class ParametrosNuevaSolicitudViewModel {
    public IdTipoSolicitud: number;
    public tipoSolicitud: string;
    public IdSubTipoSolicitud: number | null;
    public esNifExtranjero: boolean;
    public esPredua: boolean;
    public isPifCanarias: boolean;
    public EsConCF: boolean | null;
    public Mrn: string;
    public IdPaisTraslado: number;
    public IdMedioTransporteTraslado: number;
    public IdPuntoInspeccion: number;
    public FechaCartaAutorizacion: Date | null = null;
    //public Ocb: boolean;
    public esPrevia: boolean;
    public finalizaTraslado: boolean;
    public CHEDPP: string;
    public CodigoSolicitudTraslado: string;
    public esReImportacion: boolean;
    public NumCertificado: string;
    public Pin: number;
    public IdPaisTransitoDirecto: number;
    public IdMedioTransporteTransitoDirecto: number;
    public IdPaisTransbordo: number;
    public IdMedioTransporteTransbordo: number;
    public IdTipoTransbordo: number;
    public IdPuntoInspeccionTransbordo: number;
}

export class TwTracesViewModel {
    public IdSolicitud: number;
    public IdEstado: number;
    public IdEstadoDescripcion: string;
    public Codigo: string;
    public Fecha: Date | null;
}

export class TwSolicitudJerarquiaViewModel {
    public IdSolicitud: number;
    public IdSolicitudPadre: number;
    public IdTipoClonacion: number;
    public Guardada: boolean;
}

export class TcTipoSolicitudViewModel {
    public Id: number;
    public Descripcion: string;
    public Codigo: string;
    public Activo: boolean;
    public LugarDestinoImportador: boolean;
}

export class TcSubTipoSolicitudViewModel {
    public Id: number;
    public IdTipoSolicitud: number;
    public EsPreDua: boolean;
    public EsConCf: boolean | null;
}

export class TwTrasladoViewModel {
    public IdSolicitud: number;
    public IdPuntoControlTraslado: number | null = null;
    public IdPaisTrasladoDescripcion: string;
    public IdPaisTraslado: number;
    public IdPuntoControlTrasladoDescripcion: string;
    public IdPuntoControlTrasladoLocalidad: string;
    public TPuntoInspeccion: PuntoInspeccionViewModel;
    public IdMedioTransporteTraslado: number | null = null;
    public IdMedioTransporteTrasladoDescripcion: string;
    public IdAutoridadControl: number | null = null;
    public IdAutoridadControlDescripcion: string;
    public Finalizado: boolean;
}

export class TwTransitoDirectoViewModel {
    public IdSolicitud: number;
    public IdMedioTransporteTransitoDirecto: number | null = null;
    public IdMedioTransporteTransitoDirectoDescripcion: string;
}
export class TwTransbordoViewModel {
    public IdSolicitud: number;
    public IdMedioTransporteTransbordo: number | null = null;
    public IdMedioTransporteTransbordoDescripcion: string;
    public IdTipoTransbordo: number | null = null;
    public IdTipoTransbordoDescripcion: string;
    public IdPuntoInspeccionTransbordo: number | null = null;
    public IdPuntoInspeccionTransbordoDescripcion: string;
}

export class TMedioTransporteViewModel {
    public IdSolicitud: number;
    public IdMedioTransporte: number | null;
    public NumeroOMI: string;
    public FechaLlegada: Date | null;
    public NumeroDeclaracionSumaria: string;
    public Mrn: string;
    public FechaRecuperacionMrn: Date | null;
    public IdPaisMedioTransporte: number | null;
    public TcTipoMedioTranporte: Tc;
}

export class TLugarMercanciaViewModel {
    public IdSolicitud: number;
    public IdPaisOrigen: number | null;
    public IdPaisDestino: number | null;
    public IdPaisProcedencia: number | null;
    public IdAduana: number | null = null;
    public IdUbicacion: number | null;
    public FechaInspeccion: Date | null;
    public IdIntervaloHoras: number | null = null;
}

export class TUsuarioExternoViewModel {
    public IdUsuario: number;
    public NifSolicitante: string;
    public IdPais: number;
    public IdPaisDescripcion: string;
    public IdProvincia: number;
    public IdProvinciaDescripcion: string;
    public Nombre: string;
    public Apellidos: string;
    public RazonSocial: string;
    public Localidad: string;
    public NumeroTelefono: string;
    public NumeroFax: string;
    public Email: string;
    public CodigoPostal: string;
    public IdTipoVia: number;
    public IdTipoViaDescripcion: string;
    public NombreVia: string;
    public NumeroPortal: string;
    public NumeroRegistro: string;
    public NifCifRazonSocial: string;
}

export class TSolicitanteAdministrativoViewModel {
    public Id: number;
    public NifSolicitanteAdministrativo: string;
    public RazonSocialSolicitanteAdministrativo: string;
    public NumeroTelefonoSolicitanteAdministrativo: string;
}

export class TSolicitudAdministrativoViewModel {
    public IdSolicitud: number;
    public IdUsuarioGrabador: number;
    public FechaRegistro: Date | null;
    public NRegistroPapel: string;
}

export class TExportadorViewModel {
    public IdSolicitud: number;
    public NombreExportador: string;
    public CiudadExportador: string;
    public IdPaisExportador: number | null;
    public DireccionExportador: string;
    public CodigoPostalExportador = '';
}

export class TImportadorViewModel {
    public IdSolicitud: number;
    public Nif: string;
    public NRegistro: string;
    public Nombre: string;
    public Apellidos: string;
    public Direccion: string;
    public Localidad = '';
    public CodigoPostalImportador = '';
    public IdPaisImportador: number | null;
    public RefTraces: string;
    public TipoRefTraces: string;
    public OperadorTraces: string;
    public TipoOperador: string;

    /*Registro Sanitario*/
    public IdRegistroSanitario: number | null;
    public RegistroSanitario = '';
    public RazonSocialRegistroSanitario = '';
    public DireccionRegistroSanitario = '';
    public MunicipioRegistroSanitario = '';
    public ProvinciaRegistroSanitario = '';
}

export class TImportadorLugarDestinoViewModel {
    public IdSolicitud: number;
    public Nif: string;
    public NRegistro: string;
    public Nombre: string;
    public Apellidos: string;
    public Direccion: string;
    public Localidad = '';
    public CodigoPostalImpLugarDestino = '';
    public IdPaisImpLugarDestino: number | null;
    public RefTraces: string;
    public TipoRefTraces: string;
    public OperadorTraces: string;
    public TipoOperador: string;

    /*Registro Sanitario*/
    public IdRegistroSanitario: number | null;
    public RegistroSanitario = '';
    public RazonSocialRegistroSanitarioImpLugarDestino = '';
    public DireccionRegistroSanitarioImpLugarDestino = '';
    public MunicipioRegistroSanitarioImpLugarDestino = '';
    public ProvinciaRegistroSanitarioImpLugarDestino = '';
}

export class TClaveCertCanariaViewModel {
    public Certificado: string;
    public Pin: number;
}
export class PuntoInspeccionNuevaSolicitudViewModel {
    public Id: number;
    public Descripcion: string;
    public IsCanarias: boolean;
    public PcfTracesLocalidad: string;
}

export class TwFinalizacionTrasladoViewModel {
    public IdSolicitud: number;
    public ChedPpTraslado: string;
    public Finalizado: boolean;
    public DeCexveg: boolean;
}
